<template>
  <div class="page-line">
    <div class="content">
      <div class="input-content" v-if="!searchToggle">
        <i class="fa-solid fa-magnifying-glass" @click="toggleSearch"></i>
        <input class="search-input" type="text" v-model="searchData" @keydown.enter="onEnter">
      </div>

      <div class="bellow-content">
        <i class="fas fa-solid fa-magnifying-glass" v-if="searchToggle" @click="toggleSearch"></i>
      <p style="margin-left: 25px;" v-if="$store.state.isTrainee || $store.state.isLoggedIn">{{ languageText + $store.state.username }} </p>
      <button @click="toLogin()" v-if="!$store.state.isTrainee && !$store.state.isLoggedIn">
        {{ loginText }}
      </button>
      <button @click="Logout()" v-if="$store.state.isTrainee">
        {{ logoutText }}
      </button>
      <button @click="toLogin()" v-if="$store.state.isLoggedIn">
        {{ adminText }}
      </button>
      <img @contextmenu.prevent class="lang-button" src="../assets/vi_VN.png" @click="langChangeVn">
      <img @contextmenu.prevent class="lang-button" src="../assets/en_US.png" @click="langChangeEn">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      searchToggle: true,
      searchData: ''
    }
  },
  computed: {
    languageText () {
      if (this.$store.state.lang === 'vn') return 'Xin chào '
      else return 'Welcome '
    },
    loginText () {
      if (this.$store.state.lang === 'vn') return 'Đăng nhập'
      else return 'Login'
    },
    logoutText () {
      if (this.$store.state.lang === 'vn') return 'Đăng xuất'
      else return 'Logout'
    },
    adminText () {
      if (this.$store.state.lang === 'vn') return 'Đến Admin'
      else return 'to Admin'
    }
  },
  methods: {
    langChangeVn () {
      this.$store.commit('changeLangVn')
    },
    langChangeEn () {
      this.$store.commit('changeLangEn')
    },
    toLogin () {
      this.$router.push('/login')
    },
    toggleSearch () {
      this.searchToggle = !this.searchToggle
    },
    onEnter () {
      // if (this.$route.name === 'searchPage') {
      //   // Just update the inputValue based on the route param/query
      //   // this.$route.query.input = this.searchData
      //   this.$router.push({
      //     name: 'searchPage',
      //     query: { input: this.searchData }
      //   })
      // }
      // else {
      //   this.searchToggle = true
      //   // Pass inputValue as a query parameter
      //   const newUrl = this.$router.resolve({
      //     name: 'searchPage', // Replace with your actual route name
      //     query: { input: this.searchData } // Query parameter
      //   }).href
      //   window.open(newUrl, '_blank') // Open the new tab with query params
      // }
      this.searchToggle = true
      // Pass inputValue as a query parameter
      const newUrl = this.$router.resolve({
        name: 'searchPage', // Replace with your actual route name
        query: { input: this.searchData } // Query parameter
      }).href
      window.open(newUrl, '_blank') // Open the new tab with query params
      this.searchData = ''
    },
    async Logout () {
      await this.$store.dispatch('users/logout')
      this.$store.state.isTrainee = false
      this.$store.state.userId = 0
      this.$store.state.userRoles = []
      this.$store.state.userPermissions = []
      this.$store.state.userPermissionNames = []
      this.$store.state.username = ''
      this.$store.state.email = ''
      // this.$store.state.authAxios = null
      this.$store.state.token = null
      delete axios.defaults.headers.common.Authorization
      this.$store.dispatch('initializeAxios', null)
      localStorage.removeItem('storeLocal')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  .page-line {
    width: 100%;
    min-height: 36px;
    background: #000000;
    position: relative;
    z-index: 999;
  }

  .page-line .content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 170px;
    padding-top: 8px;
  }

  .bellow-content {
    display: flex;
    align-items: center;
  }

  .content button {
    padding: 2px 10px;
    margin-left: 25px;
    background: white;
    border: none;
    font-weight: 700;
    border-radius: 5px;
    cursor: pointer;
    color: #006884;
  }

  .content p {
    color: white;
  }

  .lang-button {
    cursor: pointer;
    margin-left: 25px;
  }

  i {
    color: white;
    cursor: pointer;
    caret-color: transparent;
    margin-bottom: 1px;
  }

  .input-content {
    display: block;
    position: relative;
    margin-bottom: 1px;
  }

  .input-content i {
    position: absolute;
    left: 9px;
    top: 5.5px;
    font-size: 11px;
    color: black;
  }

  .search-input {
    border-radius: 20px;
    outline: none;
    padding-left: 25px;
    padding-right: 7px;
  }

   @media (max-width: 1356px) {
    .page-line .content {
      padding: 0px 100px;
      padding-top: 6px;
    }
  }

  @media (max-width: 1080px) {
    .page-line .content {
      padding: 0px 50px;
      padding-top: 6px;
    }
  }

  @media (max-width: 720px) {
    .page-line .content {
      padding: 0px 20px;
      padding-top: 6px;
    }
  }

  @media (max-width: 650px) {
    .page-line .content {
      flex-direction: column;
      align-items: flex-end;
      padding-bottom: 8px;
    }

    .input-content {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 500px) {
    .content p{
      display: none;
    }
  }
</style>
